import React, { useRef, useEffect } from "react";
import NavbarLogo from "../../assets/evacassets/image/logo.png";
import { CButton, CCol, CContainer, CRow } from "@coreui/react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { FiArrowRight } from "react-icons/fi";

function OutSideNavBar() {
  const nav = useNavigate();
  const navLinksMobileRef = useRef(null);

  const scrollToSection = (id) => {
    const section = document.getElementById(id);
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
    }
  };

  const toggleMobileMenu = () => {
    if (navLinksMobileRef.current) {
      navLinksMobileRef.current.style.display =
        navLinksMobileRef.current.style.display === "block" ? "none" : "block";
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        navLinksMobileRef.current &&
        !navLinksMobileRef.current.contains(event.target) &&
        !event.target.closest(".menu-button")
      ) {
        navLinksMobileRef.current.style.display = "none";
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    // <header className="h-16 flex items-center">
    //   <CContainer>
    //     <CRow className="align-items-center justify-content-between ">
    //       <CCol xs="6" md="3">
    //         <motion.div
    //           initial={{ opacity: 0 }}
    //           animate={{ opacity: 1 }}
    //           transition={{ duration: 0.5 }}
    //         >
    //           <img src={NavbarLogo} alt="Logo" className="logo-img" />
    //         </motion.div>
    //       </CCol>
    //       <CCol xs="6" md="9" className="flex items-center justify-between">
    //         <div className="d-none d-md-flex  items-center flex justify-end gap-10  w-full">
    //           <motion.h5 className="nav-link" onClick={() => nav("/landing")}>
    //             Home
    //           </motion.h5>
    //           <motion.h5
    //             className="nav-link"
    //             onClick={() => {
    //               nav("/landing");
    //               setTimeout(() => {
    //                 scrollToSection("product");
    //               }, 300);
    //             }}
    //           >
    //             Product
    //           </motion.h5>
    //           <motion.h5
    //             className="nav-link"
    //             onClick={() => nav("/PrivacyPolicy")}
    //           >
    //             Privacy
    //           </motion.h5>
    //           <motion.h5
    //             className="nav-link"
    //             onClick={() => nav("/evacsupport")}
    //           >
    //             Contact
    //           </motion.h5>

    //           <div
    //             onClick={() => nav("/loginWithOTP")}
    //             className="inline-flex items-center gap-2 py-2 px-4 rounded-xl cursor-pointer
    //          bg-[#007aff] text-white font-medium transition-all duration-300 "
    //           >
    //             <span>Login</span>
    //             {/* <FiArrowRight className="text-lg" /> */}
    //           </div>
    //         </div>

    //         <div className=" d-md-none ms-auto flex gap-4 flex-row">
    //           <motion.div>
    //             <div
    //               onClick={toggleMobileMenu}
    //               className=" inline-flex items-center gap-2 py-2 px-4 rounded-xl cursor-pointer
    //          bg-[#007aff] text-white font-medium transition-all duration-300 "
    //             >
    //               <span>Menu</span>
    //               {/* <FiArrowRight className="text-lg" /> */}
    //             </div>
    //           </motion.div>
    //           {/* <motion.div>
    //             <div
    //               onClick={() => nav("/loginWithOTP")}
    //               className="inline-flex items-center gap-2 py-2 px-4 rounded-xl cursor-pointer
    //          bg-[#007aff] text-white font-medium transition-all duration-300 shadow-md"
    //             >
    //               <span>Login</span>
    //             </div>
    //           </motion.div> */}
    //         </div>
    //       </CCol>
    //     </CRow>

    //     <div
    //       ref={navLinksMobileRef}
    //       className="md:hidden mt-20 bg-white p-4 rounded-lg shadow-lg flex flex-col gap-4 transition-all duration-300 ease-in-out"
    //       style={{ display: "none" }}
    //     >
    //       <motion.h5
    //         className="nav-link cursor-pointer py-2 px-4 rounded-md  transition-colors duration-300"
    //         onClick={() => nav("/Landing")}
    //       >
    //         Home
    //       </motion.h5>
    //       <motion.h5
    //         className="nav-link cursor-pointer py-2 px-4 rounded-md  transition-colors duration-300"
    //         onClick={() => nav("/landing")}
    //       >
    //         Product
    //       </motion.h5>
    //       <motion.h5
    //         className="nav-link cursor-pointer py-2 px-4 rounded-md  transition-colors duration-300"
    //         onClick={() => nav("/PrivacyPolicy")}
    //       >
    //         Privacy
    //       </motion.h5>
    //       <motion.h5
    //         className="nav-link cursor-pointer py-2 px-4 rounded-md  transition-colors duration-300"
    //         onClick={() => nav("/evacsupport")}
    //       >
    //         Contact
    //       </motion.h5>
    //       <motion.h5
    //         className="nav-link cursor-pointer py-2 px-4 rounded-md  transition-colors duration-300"
    //         onClick={() => nav("/loginWithOTP")}
    //       >
    //         Login
    //       </motion.h5>
    //     </div>
    //   </CContainer>
    // </header>
    <header className="h-16 flex items-center">
      <div className="w-full mx-auto ">
        <div className="flex flex-wrap items-center justify-between">
          {/* Logo */}
          <div className="w-1/2 md:w-1/4 lg:pl-20 pl-4">
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.5 }}
            >
              <img src={NavbarLogo} alt="Logo" className="logo-img" />
            </motion.div>
          </div>

          {/* Desktop Menu */}
          <div className="w-1/2 md:w-3/4 flex items-center justify-between lg:pr-24 pr-4">
            <div className="hidden md:flex items-center justify-end gap-10 w-full">
              <motion.h5
                className="nav-link cursor-pointer"
                onClick={() => nav("/landing")}
              >
                Home
              </motion.h5>
              <motion.h5
                className="nav-link cursor-pointer"
                onClick={() => {
                  nav("/landing");
                  setTimeout(() => {
                    scrollToSection("product");
                  }, 300);
                }}
              >
                Product
              </motion.h5>
              <motion.h5
                className="nav-link cursor-pointer"
                onClick={() => nav("/PrivacyPolicy")}
              >
                Privacy
              </motion.h5>
              <motion.h5
                className="nav-link cursor-pointer"
                onClick={() => nav("/evacsupport")}
              >
                Contact
              </motion.h5>

              <div
                onClick={() => nav("/loginWithPassword")}
                className="inline-flex items-center gap-2 py-2 px-4 rounded-xl cursor-pointer bg-[#007aff] text-white font-medium transition-all duration-300"
              >
                <span>Login</span>
              </div>
            </div>

            {/* Mobile Menu Button */}
            <div className="md:hidden ml-auto flex gap-4 flex-row">
              <motion.div>
                <div
                  onClick={toggleMobileMenu}
                  className="inline-flex items-center gap-2 py-2 px-4 rounded-xl cursor-pointer bg-[#007aff] text-white font-medium transition-all duration-300"
                >
                  <span>Menu</span>
                </div>
              </motion.div>
            </div>
          </div>
        </div>

        {/* Mobile Dropdown Menu */}
        <div
          ref={navLinksMobileRef}
          className="md:hidden mt-20 bg-white p-4 rounded-lg shadow-lg flex flex-col gap-4 transition-all duration-300 ease-in-out"
          style={{ display: "none" }}
        >
          <motion.h5
            className="nav-link cursor-pointer py-2 px-4 rounded-md transition-colors duration-300"
            onClick={() => nav("/Landing")}
          >
            Home
          </motion.h5>
          <motion.h5
            className="nav-link cursor-pointer py-2 px-4 rounded-md transition-colors duration-300"
            onClick={() => nav("/landing")}
          >
            Product
          </motion.h5>
          <motion.h5
            className="nav-link cursor-pointer py-2 px-4 rounded-md transition-colors duration-300"
            onClick={() => nav("/PrivacyPolicy")}
          >
            Privacy
          </motion.h5>
          <motion.h5
            className="nav-link cursor-pointer py-2 px-4 rounded-md transition-colors duration-300"
            onClick={() => nav("/evacsupport")}
          >
            Contact
          </motion.h5>
          <motion.h5
            className="nav-link cursor-pointer py-2 px-4 rounded-md transition-colors duration-300"
            onClick={() => nav("/loginWithOTP")}
          >
            Login
          </motion.h5>
        </div>
      </div>
    </header>
  );
}

export default OutSideNavBar;
